module.exports = __webpack_public_path__ + "media/svg/avator-832bf5a0.svg";